<template>
  <div class="flex flex-col gap-4">
    <h3 class="text-t4 mb-1">Tillträde</h3>
    <Access v-model:access="access" @validation="accessFieldIsValid = $event" />
    <div v-if="hasRowWithErrorInApartment">
      <Pet v-model:pet="pet" v-model:petsFieldIsValid="petsFieldIsValid" />
    </div>
  </div>
</template>

<script>
import Access from './access';
import Pet from './pet';

export default {
  components: { Access, Pet },
  props: {},
  data() {
    return {
      accessFieldIsValid: false,
      petsFieldIsValid: true,
      access: {
        masterKey: true,
        phone: null,
        phoneNumber: null,
        callBetween: null,
      },
      pet: {},
    };
  },

  computed: {
    hasRowWithErrorInApartment() {
      return this.$store.getters.getErrorReportRows.some((r) => r.areaCode == 'apartment');
    },
  },
  watch: {
    access: {
      deep: true,
      handler() {
        this.update()
      }
    },
    petsFieldIsValid: {
      deep: true,
      handler() {
        this.$emit('update:petsFieldIsValid', this.petsFieldIsValid );
      }
    },
    pet: {
      deep: true,
      handler() {
        this.update()
      }
    }
  },
  methods: {
    update() {
      this.$store.dispatch('setErrorReportDraftData', {
        access: this.access,
        pet: this.pet,
      });
    },
  },

  created() {
    if (this.$store.getters.getErrorReportRows.length == 0) {
      console.error('Inga rader');
      return this.$router.replace({ name: 'ErrorReportAddNew' });
    }
    const access = this.$store.getters.getErrorReportDraft.access;
    this.access.masterKey = access.masterKey;
    this.access.phone = access.phone;
    this.access.callBetween = access.callBetween;

    this.pet = this.$store.getters.getErrorReportDraft.pet;
  },
};
</script>
